import { CoherenceDataGrid } from "@coherence-design-system/controls";
import React from "react";
import { useEffect, useState } from 'react';
import { QuotationService } from "../../services/Quotations/QuotationService";
import { ActionButton,  IIconProps,  MessageBar, MessageBarType } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { AllQuotes } from "../../models/Quotations/IAllQuotations";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { IQuotationPayload } from "../Quotation/Quotation.types";
interface IQuotationProps {
};
const AddIcon: IIconProps = { iconName: 'Add' };
export const Quotation: React.FunctionComponent<IQuotationProps> = (props) => {
    const appInsights = useAppInsightsContext();
    const navigate = useNavigate();
    const [quotationData, setQuotationData] = useState<AllQuotes[]>([]);
    const [quotationDeleteMessage, setquotationDeleteMessage] = useState(false);
    const [quotationDeleteErrorMessage, setquotationDeleteErrorMessage] = useState(false);
    useEffect(() => {
        const quotationPayload: IQuotationPayload = {
          status: 'Active',
          msContact: "SMB-CASE",
          records: 100,
          skip: 0,
          searchText: ''
        };
        QuotationService.getAllQuotation(quotationPayload)
            .then(res => {
                if (res !== undefined) {
                    setQuotationData(res.data.data);
                }
            })
            .catch(error => {
                appInsights.trackException({error, properties: {name: "In Quotation.tsx, error while getting all quotations in Quotation.tsx"}});
                console.log('Error in Quotation.tsx ' + error);
            });

    }, []);

    const _OnClickNewQuotation = () => {
        appInsights.trackEvent({ name:"In Quotation.tsx, Clicked New Quotation button to create new Quotation" });
        navigate("/CreateQuotation")
    };
    const handleDetailQuote = (id: string) => {
        appInsights.trackEvent({ name:"In Quotation.tsx, clicked Action View Quote Detail of selected quotation.", properties:{quotationId: id} });
        navigate("/QuoteDetail", { state: { searchText: id }});
    };
    return (
        <div data-testid="quotation-page">
            <div
                style={{
                    alignItems: 'flex-end'
                }}>
                <ActionButton iconProps={AddIcon} onClick={_OnClickNewQuotation}>
                    New Quotation
                </ActionButton>

                {quotationDeleteMessage && (
                    <MessageBar messageBarType={MessageBarType.success} onDismiss={() => setquotationDeleteMessage(false)}>
                        Quotation deleted successfully.
                    </MessageBar>
                )}
                {quotationDeleteErrorMessage && (
                    <MessageBar messageBarType={MessageBarType.error} onDismiss={() => setquotationDeleteErrorMessage(false)}>
                        The quotation not deleted. Please try again later.
                    </MessageBar>
                )}
            </div>
            <div
                style={{
                    marginTop: "10px",
                    height: 500,
                    background: "whitesmoke"
                }}
            >
                <CoherenceDataGrid
                    compactMode="compact"
                    data={quotationData}
                    isScrollable
                    isSortable
                    listConfig={[
                        {
                            fieldName: 'id',
                            key: 'id',
                            name: 'Quotation Id',
                            type: 'string'
                        },
                        {
                            fieldName: 'quotationNum',
                            key: 'quotationNum',
                            name: 'Quotation',
                            type: 'string'
                        },
                        {
                            fieldName: 'quotationName',
                            key: 'QuotationName',
                            name: 'Quotation Name',
                            type: 'string'
                        },
                        {
                            fieldName: 'quotationType',
                            key: 'QuotationType',
                            name: 'Quotation Type',
                            type: 'string'
                        },
                        {
                            fieldName: 'customerAccount',
                            key: 'CustomerAccount',
                            name: 'Customer Account',
                            type: 'string'
                        },
                        {
                            fieldName: 'customerName',
                            key: 'CustomerName',
                            name: 'Customer Name',
                            type: 'string'
                        },
                        {
                            fieldName: 'quotationStatus',
                            key: 'QuotationStatus',
                            name: 'Quotation Status',
                            type: 'string'
                        },
                        {
                            fieldName: 'channel',
                            key: 'Channel',
                            name: 'Channel',
                            type: 'string'
                        },
                        {
                            fieldName: 'salesOrigin',
                            key: 'SalesOrigin',
                            name: 'Sales Origin',
                            type: 'string'
                        },
                        {
                            key: 'actions',
                            name: 'Actions',
                            type: 'actions',
                            menuActions: [
                                {
                                    onClick: (quote: any) => handleDetailQuote(quote.id),
                                    key: 'action',
                                    text: 'Detail',
                                    iconProps: { iconName: 'View' }
                                },
                                {
                                    onClick: (quote: any) => console.log(quote),
                                    key: 'action',
                                    text: 'Delete',
                                    iconProps: { iconName: 'Delete' }
                                },
                            ],
                            visibleActions: []
                        }
                    ]}
                />
            </div>
        </div>
    );
}

